import styled from "styled-components";

export const TicketMobileViewHeader = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const TicketMobileViewHeaderApp = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0.6rem 0.8rem;
  margin-top: 0.6rem;
  align-items: center;
`;

export const TicketMobileViewHeaderSeparator = styled.div`
  background: linear-gradient(90deg, #3a3a3c 40%, #1c1c1e 100%);
  height: 0.1rem;
  width: 100%;
  margin-top: 0.8rem;
`;
